import { useEffect, useState } from "react";
import * as buffer from "buffer";
import {
  SlotMachine,
  SlotStatus,
} from "./components/slot-machine/slot-machine";
import { spin } from "./core/transactions";
import {
  checkIfWalletConnected,
  connectWallet,
  getBalance,
} from "./core/wallet";
import { ReactComponent as WalletSvg } from "./img/wallet.svg";
import { fetchWins, IWin } from "./services/winsService";
import ModalTokens from './components/ModalTokens';

import "./App.scss";
import { formatAddress } from "./core/utils";
import logo from "./img/logo.png";
import Win from './components/Win';

window.Buffer = buffer.Buffer;

function App() {
  const [walletAddress, setWalletAdresss] = useState("");
  const [status, setStatus] = useState(SlotStatus.none);
  const [jackpot, setJackpot] = useState("0.11");
  const [balance, setBalance] = useState("");

  const [betType, setBetType] = useState("SOL");
  const [betAmount, setbetAmount] = useState("0.1");
  const [wins, setWins] = useState<IWin[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ssmBalance, setSsmBalance] = useState(""); // Add this state

  const doFetchWins = () => {
    fetchWins().then(data => {
      if (data) {
        setWins(data);
      }
    });
  };

  useEffect(() => {
    getBalance();
    const onLoad = () => {
      checkIfWalletConnected().then((res) => {
        setWalletAdresss(res as string);
        updateBalance();
      });
    };
    window.addEventListener("load", onLoad);
    doFetchWins();
    return () => window.removeEventListener("load", onLoad);
  }, []);

  const updateBalance = (onlyWallet = false) => {
    getBalance().then((res) => {
      res.balance && setBalance(res.balance);
      res.jackpotBalance && setJackpot(res.jackpotBalance);
      res.ssmBalance && setSsmBalance(res.ssmBalance.toString()); // Add this line
      if (!onlyWallet) {
        // Add logic to set betType based on ssmBalance
        if (res.ssmBalance && parseFloat(res.ssmBalance.toString()) > 250000) {
          setBetType("SSM");
          setbetAmount("250000");
        } else {
          setBetType("SOL");
          setbetAmount("0.10");
        }
      }
    });
  };

  const modalToken = () => {
    setIsModalOpen(true);
  }

  const spinIt = () => {
    setStatus(SlotStatus.spin);

    // demo spin
    if (!walletAddress) {
      setTimeout(() => {
        setStatus(
          Math.floor(Math.random() * 2) === 0
            ? SlotStatus.loose
            : SlotStatus.win1
        );
      }, 2000);

      return;
    }

    const attemptSpin = (retry = false) => {
      spin(betType, parseFloat(betAmount), walletAddress).then((result) => {
        console.log("Spin result:", result);
        updateBalance(true);
        result = result.toString();
        switch (result) {
          case "1":
            setStatus(SlotStatus.win1);
            doFetchWins();
            break;
          case "2":
            setStatus(SlotStatus.win2);
            doFetchWins();
            break;
          case "3":
            setStatus(SlotStatus.win3);
            doFetchWins();
            break;

          default:
            setStatus(SlotStatus.loose);
        }
      }).catch((error) => {
        console.log("Spin error:", error);
        if (!retry) {
          attemptSpin(true);
        } else {
          setStatus(SlotStatus.loose);
        }
      });
    };

    attemptSpin();
  };

  return (
    <div className="App">
      <div className="header">
        {walletAddress && (
          <div className="wallet-info">
            {balance}
            <WalletSvg />
            {formatAddress(walletAddress)}
          </div>
        )}
        {!walletAddress && (
          <button
            className="button"
            onClick={() => {
              connectWallet().then((res) => {
                setWalletAdresss(res as string);
                updateBalance();
              });
            }}
          >
            Connect Wallet!
          </button>
        )}
      </div>
      <div className="cluster">

        <div>
            {wins.length > 0 && wins.map(win => (
            <Win
              key={win.tx}
              tx={win.tx}
              date={win.date}
              tokens={win.tokens}
            />
            ))}
        </div>
        <div className="footer-text">
          <p>© 2025 Launchpad Casino</p>
          <div className="footer-links">
            <a href="https://x.com/SSMCasino" target="_blank"> <img src="x.png"></img> </a>
            <a href="https://t.me/launchpadcasino" target="_blank"> <img src="telegram.png"></img> </a>
            <a href="https://dexscreener.com/solana/bre6ekdrj2ztrccqgolxcwyebptub3dxqpvyhzv7moon" target="_blank"> <img src="dexscreener.png"></img> </a>
            <a href="#" onClick={modalToken}> <img src="list.png"></img> </a>
          </div>
        </div>
      </div>
      {/* <div className="cluster">devnet</div> */}
      <div className="logo">
        <img src={logo} alt="Logo"></img>
      </div>
      <div className="contaner-positioner">
        <div className="slot-container">
          <SlotMachine
            onSpin={spinIt}
            status={status}
            jackpot={jackpot}
            walletAddress={walletAddress}
            collect={() => {
              updateBalance();
            }}
            onSpinFinished={() => {
              updateBalance();
            }}
            betType={betType}
            betAmount={betAmount}
            toggleBetType={
              () => {
                if (betType === "SOL") {
                  setBetType("SSM");
                  setbetAmount("250000");
                } else {
                  setBetType("SOL");
                  setbetAmount("0.10");
                }
              }
            }
          />
        </div>
      </div>
      <ModalTokens isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default App;
